
export function onStepperButtonClick(event) {
	const btn = event.target.closest('.increment, .decrement');
	if (!btn) return;
	if (btn.offsetParent === null) return; // Skip hidden steppers

	const stepper = btn.closest('.atb-stepper');
	const counter = stepper.querySelector('.counter');

	const min = parseInt(counter.dataset.min);
	const max = parseInt(counter.dataset.max);
	let value = parseInt(counter.value) || 0;

	// If the button clicked was 'increment' evaluate the clamped value
	if (btn.classList.contains('increment'))
		value = Math.min(value + 1, max);
	else
		value = Math.max(value - 1, min);
	
	counter.value = value;
	syncStepperButtons(stepper, value, min, max);
	announceStepperValue(stepper, value);

	counter.dispatchEvent(new Event('change', { bubbles: true }));
}


/**
 * Announces the new stepper value to screen reader users via a visually-hidden live region,
 * since the +/- buttons and readonly counter input give no other feedback when activated.
 *
 * @param {HTMLElement} stepperEl - DOM element wrapping the stepper component
 * @param {number} value - new value of the stepper
 * @returns {void}
 */
function announceStepperValue(stepperEl, value) {
	const announcement = stepperEl.querySelector('[id$="-announcement"]');
	if (!announcement) return;

	const label = stepperEl.querySelector('label span.atb-stepper-type')?.textContent.trim() ?? '';
	announcement.textContent = `${label}: ${value}`;
}


/**
 * Used by the stepper event-handler to keep the UI synchronised depending on whether 
 * the value equals the minimum or maximum for the stepper
 * 
 * @param {HTMLElement} stepperEl - DOM element wrapping the stepper component 
 * @param {number} value - new value of the stepper as a result of user interaction
 * @param {number} min - min value allowed for this stepper
 * @param {number} max - max value allowed for this stepper
 * @returns {void}
 */
export function syncStepperButtons(stepperEl, value, min, max) {
    const inc = stepperEl.querySelector('.increment');
    const dec = stepperEl.querySelector('.decrement');

    if (!inc || !dec) return;

    inc.disabled = value >= max;
    dec.disabled = value <= min;
}


// TODO: Duplicate logic in event-handler.js could, with a little adjustment, be replaced with this
/**
 * Used to programmatically set the value of a stepper given it's wrapper element and value
 * 
 * @param {*} stepperEl 
 * @param {*} value 
 */
export function setStepperValue(stepperEl, value, doFireChangeEvent = false) {
	const counter = stepperEl.querySelector('.counter');

	const min = parseInt(counter.dataset.min, 10);
	const max = parseInt(counter.dataset.max, 10);

	const state = calculateStepperState({
		value,
		min,
		max
	});

	updateStepperUI(stepperEl, state, doFireChangeEvent);
}

function updateStepperUI(stepperEl, state, doFireChangeEvent = false) {
	const counter = stepperEl.querySelector('.counter');
    counter.value = state.value;

    if (doFireChangeEvent) counter.dispatchEvent(new Event('change', { bubbles: true }));

	stepperEl.querySelector('.decrement')
		.toggleAttribute('disabled', state.disableDecrement);

	stepperEl.querySelector('.increment')
		.toggleAttribute('disabled', state.disableIncrement);
}

function calculateStepperState({
	value,
	min,
	max
}) {
    // Clamp the value between the minimum and maximum
    const clampedValue = Math.min(Math.max(value, min), max);

    return {
        value: clampedValue,
        disableDecrement: clampedValue === min,
        disableIncrement: clampedValue === max
    };
}